export default {
  title: 'Información personal',
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    personal_info_updated_successfully: 'Información guardada correctamente',
  },
};
